module.exports = __webpack_public_path__ + "static/media/Madfit-11.f5e919ce.jpg";